// All coffees, the peek. On a desktop the peek is CSS only (hover or focus). On a phone, or any screen without hover, a tap
// on a row opens its peek as a sheet over a blurred page; the name still goes to the coffee and Add still adds. The
// sheet closes on its × , on the page behind it, on Escape or on a swipe down. The "also" link salesol-lenses.js adds to a
// sold-out row is moved into the peek, where the details live.
(() => {
  const sheetMode = () => matchMedia('(hover: none), (max-width: 760px)').matches;
  let scrim = null, open = null, y0 = null;
  // the scrim sits in the open row, just before its sheet, so the two always share one stacking context (an ancestor of
  // the row can open a context of its own, and a scrim outside it would then cover the sheet)
  const ensureScrim = (row) => {
    if (!scrim) { scrim = document.createElement('div'); scrim.className = 'lr-scrim'; scrim.setAttribute('aria-hidden', 'true'); scrim.addEventListener('click', (e) => { e.stopPropagation(); close(); }); }
    const peek = row.querySelector('.lr-peek'); if (peek && scrim.nextElementSibling !== peek) row.insertBefore(scrim, peek);
  };
  const mirror = (row) => { const p = row.querySelector('[data-shop-buy] [data-price]'), sp = row.querySelector('.lr-sheet-price'); if (p && sp) sp.textContent = p.textContent.trim(); };
  function show(row) {
    if (open) close(true);
    ensureScrim(row); open = row; mirror(row);
    row.classList.add('is-open'); scrim.classList.add('on');
    const more = row.querySelector('.lr-more'); if (more) more.setAttribute('aria-expanded', 'true');
    document.documentElement.style.overflow = 'hidden';
    const c = row.querySelector('.lr-close'); if (c) c.focus({ preventScroll: true });
  }
  function close(quiet) {
    if (!open) return;
    const row = open; open = null;
    row.classList.remove('is-open'); if (scrim) scrim.classList.remove('on');
    const more = row.querySelector('.lr-more'); if (more) { more.setAttribute('aria-expanded', 'false'); if (!quiet) more.focus({ preventScroll: true }); }
    document.documentElement.style.overflow = '';
  }
  function mount(box) {
    if (box.__lp) return; box.__lp = 1;
    const moveAlso = () => box.querySelectorAll('.lr [data-also]').forEach((a) => { const slot = a.closest('.lr').querySelector('.lr-also'); if (slot && a.parentElement !== slot) slot.append(a); });
    moveAlso(); new MutationObserver(moveAlso).observe(box, { childList: true, subtree: true });
    box.addEventListener('click', (e) => {
      const row = e.target.closest('.lr'); if (!row) return;
      if (e.target.closest('.lr-close')) { close(); return; }
      if (e.target.closest('.lr-add')) { const add = row.querySelector('[data-shop-buy] [data-add]'); close(true); if (add) add.click(); return; }
      if (e.target.closest('[data-size-pick], .lr-peek button')) { requestAnimationFrame(() => mirror(row)); return; }
      if (!sheetMode() || e.target.closest('.lr-peek, a, [data-add], [data-sold-pill]')) return;
      e.preventDefault(); show(row);
    });
    // a swipe down on the sheet closes it
    box.addEventListener('touchstart', (e) => { if (open && e.target.closest('.lr-peek')) { const pk = open.querySelector('.lr-peek'); y0 = pk.scrollTop <= 0 ? e.touches[0].clientY : null; } }, { passive: true });
    box.addEventListener('touchmove', (e) => { if (y0 !== null && open && e.touches[0].clientY - y0 > 70) { y0 = null; close(); } }, { passive: true });
  }
  addEventListener('keydown', (e) => { if (e.key === 'Escape') close(); });
  addEventListener('resize', () => { if (open && !sheetMode()) close(true); });
  const run = (root) => (root || document).querySelectorAll('[data-lens-rows]').forEach(mount);
  const S = window.Salesol || {};
  if (S.boot) S.boot(run); else if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => run()); else run();
  document.addEventListener('shopify:section:load', (e) => run(e.target));
})();
